import { createContextKey } from '@opentelemetry/api'

export const INSTRUMENTATION_NAME = 'di.app'

// Default values copied from defaults in BatchSpanProcessorBase as it's not easy to refer to them programmatically
export const DEFAULT_MAX_EXPORT_BATCH_SIZE = 512
export const DEFAULT_MAX_QUEUE_SIZE = 2048
export const DEFAULT_SCHEDULE_DELAY = 5000
export const DEFAULT_EXPORT_TIMEOUT = 30000

// A context key to indicate that the current execution context is a "background flow" (e.g. surgery booking spans),
// rather than a UI-blocking flow (e.g. loading spans)
export const BACKGROUND_FLOW_CONTEXT_KEY = createContextKey('di.background_flow')
